import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

/**
 * Bottom-of-page conversion strip for /employers.
 * Composes an existing Shadcn Button on a subtle gradient background.
 */
export const EmployerFooterCTA = () => (
  <section
    className="py-16 lg:py-20 bg-gradient-to-r from-blue-600 to-indigo-600"
    data-testid="employer-footer-cta"
  >
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
        Ready to meet stronger applicants?
      </h2>
      <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
        Tell us about the role you&apos;re hiring for and we&apos;ll follow up with a
        tailored proposal.
      </p>
      <Link to="/employers/intake">
        <Button
          size="lg"
          className="bg-white text-blue-700 hover:bg-blue-50 text-lg px-8 py-3 shadow-lg"
          data-testid="employer-footer-cta-button"
        >
          Request your Employer Intake Package
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </Link>
    </div>
  </section>
);
